import {
    SYSTEM_LOG_REQUEST,
    SYSTEM_LOG_SUCCESS,
    SYSTEM_LOG_FAIL,
    TRANSACTION_LOG_REQUEST,
    TRANSACTION_LOG_SUCCESS,
    TRANSACTION_LOG_FAIL,
    USERS_LOG_REQUEST,
    USERS_LOG_SUCCESS,
    USERS_LOG_FAIL,
} from '../constants/action-types';

import { getSystemLogRequest, getDailyUsersLogRequest, getTransactionLogRequest } from '../services/api';

const getTransactionLogList =
    ({ page, ...otherFilters }) =>
    async (dispatch, getState) => {
        dispatch({
            type: TRANSACTION_LOG_REQUEST,
        });
        const { transactionlogs: logs } = getState().systemlogs;
        try {
            const { data } = await getTransactionLogRequest({ page, ...otherFilters });
            const totalResults = +page === 1 ? data : [...logs, ...data];
            const hasMore = !!(data && data.length > 0);

            dispatch({
                type: TRANSACTION_LOG_SUCCESS,
                payload: { hasMore, transactionlogs: totalResults },
            });
        } catch (error) {
            dispatch({
                type: TRANSACTION_LOG_FAIL,
                error,
            });
        }
    };

const getSystemLogList =
    ({ page, ...otherFilters }) =>
    async (dispatch, getState) => {
        const { logs } = getState().systemlogs;
        dispatch({
            type: SYSTEM_LOG_REQUEST,
        });
        try {
            const { data } = await getSystemLogRequest({ page, ...otherFilters });
            const hasMore = !!(data && data.length > 0);
            const totalResults = +page === 1 ? data : [...logs, ...data];

            dispatch({
                type: SYSTEM_LOG_SUCCESS,
                payload: { hasMore, logs: totalResults },
            });
        } catch (error) {
            dispatch({
                type: SYSTEM_LOG_FAIL,
                error,
            });
        }
    };

const getDailyUsersLog = () => async dispatch => {
    dispatch({
        type: USERS_LOG_REQUEST,
    });
    try {
        const result = await getDailyUsersLogRequest();
        dispatch({
            type: USERS_LOG_SUCCESS,
            payload: result.data,
        });
    } catch (error) {
        dispatch({
            type: USERS_LOG_FAIL,
            error,
        });
    }
};

export { getTransactionLogList, getSystemLogList, getDailyUsersLog };



// WEBPACK FOOTER //
// ./source/actions/systemLogActions.js